import styled from 'styled-components';

export const Container = styled.div`
  .transition-icon {
    transition: transform 0.3s ease;
  }

  button[aria-expanded='true'] .transition-icon {
    transform: rotate(180deg);
  }

  button:focus,
  select:focus {
    outline: none;
    box-shadow: none;
  }

  .card-titulo {
    border-radius: 4px 4px 0px 0px;
    background-color: #f7ecd0;
  }
`;
